import { createSlice } from "@reduxjs/toolkit";

export const travellerSlice = createSlice({
  name: "travellers",
  initialState: [],
  reducers: {
    addTraveller: (state, action) => {
      state.push(action.payload);
    },
  },
});

export const { addTraveller } = travellerSlice.actions
export default travellerSlice.reducer;